<template>
	<dropdown class="flex items-center justify-center" nudge-right width="400" :max-height="500">
		<div class="relative">
			<btn small icon rounded-full :class="!isOnline ? 'bg-warning' : 'bg-gray-300'" :aria-label="$t('label.notifications')">
				<Icon v-if="!isOnline" :icon="icons.offline" color="white" :size="18" force-size/>
				<Icon v-else :icon="icons.notification" color="white" :size="18" force-size/>
			</btn>
			<badge v-if="globalStore.unreadNotificationsCount > 0" absolute right top rounded-full color="secondary">{{ limit(globalStore.unreadNotificationsCount, 10) }}</badge>
			<badge v-else-if="props.requiresInteraction" absolute right top rounded-full small color="secondary"/>
		</div>

		<template #title>
			<div class="flex justify-between items-center px-16 my-8">
				<div class="font-bold text-sm">{{ $t('label.notifications') }}</div>
				<slot name="title_right"/>
			</div>
		</template>

		<template #menu>
			<div>
				<client-only>
					<div v-if="!isOnline" class="px-16 py-8">
						<lazy-offline-alert/>
					</div>
					<template v-else>
						<slot/>
						<lazy-notification-list v-if="$auth.loggedIn"/>
						<lazy-login-to-see-more v-else :text="$t('missing.notifications.unauthenticated')" no-spacing tile vertical/>
					</template>
				</client-only>
			</div>
		</template>
	</dropdown>
</template>

<script setup lang="ts">
import {mdiBellOutline, mdiWifiStrengthAlertOutline} from "@mdi/js";
import {limit} from "@spoferan/spoferan-ts-core";
import { useOnline } from '@vueuse/core'
import {useGlobalStore} from "../../store";

const props = defineProps<{
	requiresInteraction?: boolean,
}>();

const isOnline = useOnline()
const globalStore = useGlobalStore();

const icons = {
	notification: mdiBellOutline,
	offline: mdiWifiStrengthAlertOutline,
};

</script>